import WithRender from "../../templates/layouts/layoutUploadFullPageConfiguration.html";

export default WithRender({
  computed: {}
});
